let module = {};

/**
 * Container Initialization
 */
module.init = function () {
    const filterSelects = document.querySelectorAll('.js-filter-select');

    filterSelects.forEach(filterSelect => {
        const filters = [filterSelect];

        filterSelect.addEventListener('change', () => {
            module.handleFilterChanges(filters);
        });
    });
};

module.handleFilterChanges = (filters) => {

    // Get the current URL
    const currentURL = new URL(window.location.href);

    // Get the existing URL parameters
    const urlParams = currentURL.searchParams;

    for (let filter of filters) {
		if (filter.value) {
			urlParams.set(filter.getAttribute('data-filter'), filter.value);
		} else {
            urlParams.delete(filter.getAttribute('data-filter'));
        }
	}

    // Construct the updated URL
    const updatedUrl = `${currentURL.origin}${currentURL.pathname}?${urlParams.toString()}${currentURL.hash}`;

    // check to see if user is filtering from a paged view
    // if so redirect them to page 1
    if (updatedUrl.includes('/page/')) {
        location.href = location.pathname.replace(/page\/[0-9+]/, '') + '?' + urlParams.toString();
    } else if (!urlParams.toString()) {
        location.href = location.pathname;
    } else {
        location.search = urlParams.toString();
    }
};

document.addEventListener("DOMContentLoaded", () => {
    module.init();
});
